// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"24":"1c484de2b0078124","651":"3a61127a96893fb0"}[chunkId] + ".js";
};